module.exports = __webpack_public_path__ + "static/img/icon_j1.8a95d9f5.png";